// @flow

import * as React from 'react'
import type { Node } from 'react'

import { Toaster } from './ui/sonner'

type RootWrapProps = {
  element: Node,
}

export function RootWrap({ element }: RootWrapProps): Node {
  return (
    <>
      {element}
      <Toaster />
    </>
  )
}

export default RootWrap
